import Vue from 'vue';
import Datepicker from 'vuejs-datepicker';
Vue.component('date-picker', Datepicker);
